import { render, staticRenderFns } from "./LongTextField.vue?vue&type=template&id=6a181793"
import script from "./LongTextField.vue?vue&type=script&lang=js"
export * from "./LongTextField.vue?vue&type=script&lang=js"
import style0 from "./LongTextField.vue?vue&type=style&index=0&id=6a181793&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports